import { getBackVersion } from '../../config';
import { IcatuCapBondSnapshot } from '../../models';
import api from '../api';

const getIcatuCapBond = (capId: string): Promise<IcatuCapBondSnapshot> =>
    api.request<IcatuCapBondSnapshot>({
        url: `${getBackVersion()}/agent/cap/${capId}/bond`,
        method: 'GET',
    });

export { getIcatuCapBond };
